// extracted by mini-css-extract-plugin
module.exports = {"root":"_1pt7e","TextOnlyMenuButtonNSkin":"_3KF65","textOnlyMenuButtonNSkin":"_3KF65","linkElement":"_2DUrw","wrapper":"_1u8sp","label":"_1zyfI"};